import { tv } from 'tailwind-variants';

export const dialogStyles = tv({
  slots: {
    base: 'relative z-30',
    backdrop:
      'fixed inset-0 bg-black/75 duration-300 ease-out data-closed:opacity-0',
    mainWrapper: 'fixed inset-0 overflow-y-auto',
    main: 'flex min-h-full items-center',
    panel:
      'relative h-auto w-fit transform bg-transparent transition-all ease-out data-closed:scale-95 data-closed:opacity-0 duration-300 z-50'
  },
  variants: {
    alignment: {
      center: {
        main: 'justify-center'
      },
      left: {
        main: 'justify-start'
      },
      right: {
        main: 'justify-end'
      }
    }
  },
  defaultVariants: {
    alignment: 'center'
  }
});
